import { refreshToken } from "./nimbleAPI";

let token = null;
let refAuthID = null;
let refreshTimer = null;
let urlVersion = null;



// export function setToken(newToken, minutesToExpire, newRefAuthID, urlV) {
//     // export function setToken(newToken) {
//     token = newToken;
//     refAuthID = newRefAuthID;
//     urlVersion = urlV
//     scheduleRefresh(minutesToExpire);
// };


export function setToken(
    newToken,
    minutesToExpire = null,
    newRefAuthID = null,
    urlV = null,
    enableRefresh = false
) {
    token = newToken;
    refAuthID = newRefAuthID;
    urlVersion = urlV;

    if (enableRefresh && minutesToExpire) {
        scheduleRefresh(minutesToExpire);
    }
}

// export function setToken(newToken) {
//     token = newToken;
// };

export function getToken() {
    return token;
};

function scheduleRefresh(minutesToExpire) {
    if (refreshTimer) clearTimeout(refreshTimer);

    const refreshInMs = Math.max((minutesToExpire - 2) * 60 * 1000, 0);
    refreshTimer = setTimeout(async () => {
        const result = await refreshToken(token, urlVersion, refAuthID);
        if (result) {
            setToken(result.token, result.minutesToExpire, result.refAuthID, urlVersion ,true);
        }
    }, refreshInMs);
};


